/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamAnalysisWorkStepDto } from './BeamAnalysisWorkStepDto';
import {
    BeamAnalysisWorkStepDtoFromJSON,
    BeamAnalysisWorkStepDtoFromJSONTyped,
    BeamAnalysisWorkStepDtoToJSON,
} from './BeamAnalysisWorkStepDto';
import type { BeamAnalysisWorkItemDtoCorrectionSettings } from './BeamAnalysisWorkItemDtoCorrectionSettings';
import {
    BeamAnalysisWorkItemDtoCorrectionSettingsFromJSON,
    BeamAnalysisWorkItemDtoCorrectionSettingsFromJSONTyped,
    BeamAnalysisWorkItemDtoCorrectionSettingsToJSON,
} from './BeamAnalysisWorkItemDtoCorrectionSettings';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { WorkItemSource } from './WorkItemSource';
import {
    WorkItemSourceFromJSON,
    WorkItemSourceFromJSONTyped,
    WorkItemSourceToJSON,
} from './WorkItemSource';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface BeamAnalysisWorkItemDto
 */
export interface BeamAnalysisWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    taskInJobId?: string;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof BeamAnalysisWorkItemDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof BeamAnalysisWorkItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof BeamAnalysisWorkItemDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {WorkItemSource}
     * @memberof BeamAnalysisWorkItemDto
     */
    source?: WorkItemSource;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamAnalysisWorkItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<BeamAnalysisWorkStepDto>}
     * @memberof BeamAnalysisWorkItemDto
     */
    workSteps?: Array<BeamAnalysisWorkStepDto> | null;
    /**
     * 
     * @type {BeamAnalysisWorkItemDtoCorrectionSettings}
     * @memberof BeamAnalysisWorkItemDto
     */
    correctionSettings?: BeamAnalysisWorkItemDtoCorrectionSettings | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkItemDto
     */
    $type?: BeamAnalysisWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisWorkItemDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationJobExecutionDtoBeamAnalysisWorkItemDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkItemDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisWorkItemDtoTypeEnum = typeof BeamAnalysisWorkItemDtoTypeEnum[keyof typeof BeamAnalysisWorkItemDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisWorkItemDto interface.
 */
export function instanceOfBeamAnalysisWorkItemDto(value?: unknown): value is BeamAnalysisWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisWorkItemDtoTypeEnum)[0];
}

export function BeamAnalysisWorkItemDtoFromJSON(json: any): BeamAnalysisWorkItemDto {
    return BeamAnalysisWorkItemDtoFromJSONTyped(json, false);
}

export function BeamAnalysisWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'taskInJobId': json['taskInJobId'] == null ? undefined : json['taskInJobId'],
        'name': json['name'] == null ? undefined : json['name'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'taskAreaId': json['taskAreaId'] == null ? undefined : json['taskAreaId'],
        'supportSystemIds': json['supportSystemIds'] == null ? undefined : ((json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': json['description'] == null ? undefined : json['description'],
        'instruction': json['instruction'] == null ? undefined : InstructionDtoFromJSON(json['instruction']),
        'source': json['source'] == null ? undefined : WorkItemSourceFromJSON(json['source']),
        'commentEntityCompositeId': json['commentEntityCompositeId'] == null ? undefined : json['commentEntityCompositeId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'workSteps': json['workSteps'] == null ? undefined : ((json['workSteps'] as Array<any>).map(BeamAnalysisWorkStepDtoFromJSON)),
        'correctionSettings': json['correctionSettings'] == null ? undefined : BeamAnalysisWorkItemDtoCorrectionSettingsFromJSON(json['correctionSettings']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisWorkItemDtoToJSON(value?: Omit<BeamAnalysisWorkItemDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'taskInJobId': value['taskInJobId'],
        'name': value['name'],
        'taskId': value['taskId'],
        'taskAreaId': value['taskAreaId'],
        'supportSystemIds': value['supportSystemIds'] == null ? undefined : ((value['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value['iuid'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'description': value['description'],
        'instruction': InstructionDtoToJSON(value['instruction']),
        'source': WorkItemSourceToJSON(value['source']),
        'commentEntityCompositeId': value['commentEntityCompositeId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'workSteps': value['workSteps'] == null ? undefined : ((value['workSteps'] as Array<any>).map(BeamAnalysisWorkStepDtoToJSON)),
        'correctionSettings': BeamAnalysisWorkItemDtoCorrectionSettingsToJSON(value['correctionSettings']),
        '$type': value['$type'],
    });
}

